/* A guide: breadcrumbs, title block, cover, then the reading column. */
.article {
  max-width: 880px;
  margin: 0 auto;
  padding: 20px var(--gutter) 24px;
  box-sizing: content-box;
}

.crumbs {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
  font-size: 13px;
  color: var(--text-secondary);
}

.crumb {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
}

.crumb + .crumb::before {
  content: '/';
  padding: 0 10px;
  color: var(--text-muted);
}

.header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--label);
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 36px;
  line-height: 1.05;
}

.meta {
  margin: 0;
  font-size: 13px;
  color: var(--text-muted);
}

.hero {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  margin-bottom: 32px;
  border-radius: var(--radius-card);
  background: var(--band);
}

@media (min-width: 1024px) {
  .article {
    padding-top: 28px;
  }

  .title {
    font-size: 52px;
  }

  .hero {
    margin-bottom: 44px;
  }
}
